import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { ProjectResolver } from '@/features/shell/project-resolver';

/** `/$tenant/code-assistant` — entrée « Assistant de code » hors projet : redirige vers le dernier projet ouvert (lot L08). */
export const Route = createFileRoute('/$tenant/code-assistant')({ component: CodeAssistantRedirect });

function CodeAssistantRedirect() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="codeAssistant"
      crumbs={[{ label: t('nav.items.codeAssistant') }]}
    >
      <ProjectResolver tenantId={tenant} section="codeAssistant" />
    </ConsoleShell>
  );
}
